export const filterLabels = {
  costInPoints: "priceInUnits",
  "customerData:email": "email",
  "customerData:firstName": "firstName",
  "customerData:lastName": "lastName",
  "customerData:loyaltyCardNumber": "loyaltyCardNumber",
  "customerData:phone": "phoneNumber",
  customerId: "memberID",
  rewardType: "rewardType",
  redemptionDate: "redemptionDate",
  rewardId: "rewardId",
  name: "rewardName",
  status: "status",
  code: "code",
};

export const rewardFulfillmentFilterLabelsList = Object.keys(filterLabels).map(
  (key) => ({
    id: key,
    label: filterLabels[key as keyof typeof filterLabels],
  }),
);
